import { render, staticRenderFns } from "./TableReceived.vue?vue&type=template&id=32bd3972&"
import script from "./TableReceived.vue?vue&type=script&lang=js&"
export * from "./TableReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports